import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Client } from '../../client/classes/client';
import { KieneBackendApiService } from '../../../services/backend-api/kiene-backend-api.service';
import { API_BASE_URL_SERVICE } from '../../../kiene-core.config';
import { FormControl } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { MessageService } from '../../../services/message-service/message.service';

@Component({
    selector: 'kiene-tierliste-schlachthof-auswahl-dialog',
    templateUrl: './tierliste-schlachthof-auswahl-dialog.component.html',
    styleUrls: ['./tierliste-schlachthof-auswahl-dialog.component.scss'],
})
export class TierlisteSchlachthofAuswahlDialogComponent implements OnInit {
    schlachthoefe: Client[] = [];
    schlachthofCtrl = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<TierlisteSchlachthofAuswahlDialogComponent>,
        private api: KieneBackendApiService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {
        const params = new HttpParams().set('intern', 0).set('extern', 0).set('schlachthof', 1);
        this.api.getAll(this.apiBaseUrl + 'kunde_kunde/read_kundenportal.php', params).subscribe({
            next: response => {
                // Filtere Schlachthöfe mit "Schlachtbetrieb aus HIT" heraus
                this.schlachthoefe = response.records.filter(
                    schlachthof => !schlachthof.bezeichnung?.toLowerCase().includes('schlachtbetrieb aus hit'),
                );
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    cancel() {
        this.dialogRef.close();
    }

    select() {
        if (this.schlachthofCtrl.value) {
            this.dialogRef.close(this.schlachthofCtrl.value);
        }
    }
}
